/* HDC Rollrasen-Rechner – Oberfläche vor dem Apippa Custom Price Calc (Herbst 2026) */
(function () {
  if (window.hdcRechner) return;
  window.hdcRechner = true;

  var API = 'https://api.custompricecalculator.com/api/v1/';
  var money = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });
  var number = new Intl.NumberFormat('de-DE');

  function euro(value) { return money.format(value); }
  function euroShort(value) { return value % 1 === 0 ? number.format(value) + ' €' : money.format(value); }
  function perM2(value) { return money.format(value).replace(/\s?€/, ' €'); }

  function init(root) {
    var cfg = JSON.parse(root.getAttribute('data-config'));
    var scope = root.closest('.product-info') || document;
    var extras = scope.querySelector('[data-hdc-rechner-extras]') || document.querySelector('[data-hdc-rechner-extras]');
    var dummy = document.createElement('div');
    function q(sel) { return root.querySelector(sel) || (extras && extras.querySelector(sel)) || dummy.appendChild(document.createElement('div')); }
    var el = {
      input: root.querySelector('[data-r-input]'),
      chips: q('[data-r-chips]'),
      total: q('[data-r-total]'),
      breakdown: q('[data-r-breakdown]'),
      nudge: q('[data-r-nudge]'),
      tiers: q('[data-r-tiers]'),
      gift: q('[data-r-gift]'),
      giftText: q('[data-r-gift-text]'),
      giftBar: q('[data-r-gift-bar]'),
      split: q('[data-r-split]'),
      limit: q('[data-r-limit]'),
      measure: root.querySelector('#hdc-r-measure'),
      measureToggle: root.querySelector('[data-r-measure-toggle]'),
      length: root.querySelector('[data-r-length]'),
      width: root.querySelector('[data-r-width]'),
      reserve: root.querySelector('[data-r-reserve]'),
      measureResult: q('[data-r-measure-result]')
    };
    /* Texte je Seite (Standard = Lieferung) */
    if (cfg.priceSuffix == null) cfg.priceSuffix = ' · inkl. 7 % MwSt. & Lieferung';
    if (cfg.minHint == null) cfg.minHint = 'Lieferung ab ' + cfg.min + ' m². Kleinere Flächen können Sie <a href="' + cfg.pickupUrl + '">bei uns abholen →</a>';
    /* Fläche aus dem Link übernehmen (?flaeche=263, auch ?qm= / ?area=), z. B. von Landingpage oder Warenkorb */
    var params = new URLSearchParams(window.location.search);
    var linkM2 = String(params.get('flaeche') || params.get('qm') || params.get('area') || '').trim();
    if (/^[0-9]{1,5}$/.test(linkM2) && +linkM2 > 0) el.input.value = linkM2;
    /* ?ersetzen=<Warenkorb-Zeile>: diese Zeile beim Klick auf „In den Warenkorb“ vorher entfernen (Fläche ändern) */
    var replaceKey = params.get('ersetzen');
    var state = { m2: clamp(parseInt(el.input.value, 10) || cfg.defaultM2) };

    /* ---------- Preislogik (identisch zur App-Formel: m² × Staffelpreis + Mindermengenzuschlag) ---------- */
    function clamp(m2) { return Math.min(cfg.max, Math.max(cfg.min, Math.round(m2))); }
    function tierFor(m2) {
      for (var i = 0; i < cfg.tiers.length; i++) {
        if (m2 >= cfg.tiers[i].from && m2 <= cfg.tiers[i].to) return cfg.tiers[i];
      }
      return cfg.tiers[cfg.tiers.length - 1];
    }
    function surchargeFor(m2) {
      for (var i = 0; i < cfg.surcharge.length; i++) {
        if (m2 >= cfg.surcharge[i].from && m2 <= cfg.surcharge[i].to) return cfg.surcharge[i].amount;
      }
      return 0;
    }
    function totalFor(m2) { return Math.round((m2 * tierFor(m2).price + surchargeFor(m2)) * 100) / 100; }

    /* Schwellen, ab denen es günstiger wird: Staffelstufen + Ende des Zuschlags */
    function thresholds() {
      var list = cfg.tiers.slice(1).map(function (t) { return { m2: t.from, kind: 'tier', price: t.price }; });
      cfg.surcharge.forEach(function (s) {
        if (s.to + 1 >= cfg.min) list.push({ m2: s.to + 1, kind: 'surcharge', amount: s.amount });
      });
      return list.sort(function (a, b) { return a.m2 - b.m2; });
    }

    /* ---------- Darstellung ---------- */
    function renderChips() {
      el.chips.innerHTML = '';
      cfg.quick.forEach(function (m2) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'hdc-r__chip';
        b.setAttribute('data-m2', m2);
        b.innerHTML = '<span class="hdc-r__chip-m">' + m2 + ' m²</span>' +
          '<span class="hdc-r__chip-p">' + euroShort(totalFor(m2)) + '</span>' +
          (m2 === cfg.popularM2 ? '<em>Beliebt</em>' : '');
        b.addEventListener('click', function () { set(m2); });
        el.chips.appendChild(b);
      });
    }

    /* „ab X €/m²“ überall dort, wo data-r-from-price steht (günstigste Staffel) */
    function renderFromPrice() {
      var low = Math.min.apply(null, cfg.tiers.map(function (t) { return t.price; }));
      document.querySelectorAll('[data-r-from-price]').forEach(function (n) { n.textContent = perM2(low); });
    }

    function renderTiers() {
      renderFromPrice();
      el.tiers.innerHTML = '';
      cfg.tiers.forEach(function (t) {
        var li = document.createElement('li');
        li.setAttribute('data-from', t.from);
        li.innerHTML = '<span>ab ' + number.format(t.from) + ' m²</span><b>' + perM2(t.price) + '</b>';
        el.tiers.appendChild(li);
      });
    }

    function render() {
      var m2 = state.m2;
      var tier = tierFor(m2);
      var surcharge = surchargeFor(m2);
      var total = totalFor(m2);

      el.total.textContent = euro(total);
      el.breakdown.textContent = number.format(m2) + ' m² × ' + perM2(tier.price) +
        (surcharge ? ' + ' + euro(surcharge) + ' Mindermengenzuschlag' : '') +
        cfg.priceSuffix;

      [].forEach.call(el.chips.children, function (chip) {
        chip.classList.toggle('is-active', +chip.getAttribute('data-m2') === m2);
      });
      [].forEach.call(el.tiers.children, function (li) {
        li.classList.toggle('is-active', +li.getAttribute('data-from') === tier.from);
      });

      renderNudge(m2, total);
      renderGift(m2);
      renderSplit(m2);
    }

    function renderNudge(m2, total) {
      var next = thresholds().filter(function (t) { return t.m2 > m2; });
      var cheaper = next.filter(function (t) { return totalFor(t.m2) <= total; })[0];
      var html = '';
      if (cheaper) {
        var diff = total - totalFor(cheaper.m2);
        var more = cheaper.m2 - m2;
        html = '💡 <b>' + number.format(more) + ' m² mehr = ' + euro(diff) + ' günstiger</b> (' + number.format(cheaper.m2) + ' m² für ' + euro(totalFor(cheaper.m2)) + ')' +
          ' <button type="button" class="hdc-r__nudge-btn" data-m2="' + cheaper.m2 + '">Auf ' + number.format(cheaper.m2) + ' m² erhöhen</button>';
      } else if (next.length) {
        var n = next[0];
        var gap = n.m2 - m2;
        if (n.kind === 'surcharge') {
          html = 'Ab ' + number.format(n.m2) + ' m² entfällt der Mindermengenzuschlag von ' + euro(n.amount) + '.';
        } else if (gap <= 60) {
          html = 'Noch <b>' + number.format(gap) + ' m²</b> bis zum Staffelpreis von ' + perM2(n.price) + '/m².';
        }
      }
      el.nudge.innerHTML = html;
      el.nudge.hidden = !html;
      var btn = el.nudge.querySelector('[data-m2]');
      if (btn) btn.addEventListener('click', function () { set(+btn.getAttribute('data-m2')); });
    }

    function renderGift(m2) {
      if (!cfg.giftEnabled || !cfg.giftVariantId) { el.gift.hidden = true; return; }
      var reached = m2 >= cfg.giftThreshold;
      el.gift.hidden = false;
      el.gift.classList.toggle('is-reached', reached);
      el.giftText.innerHTML = reached
        ? '🎁 <b>Gratis dazu:</b> ' + cfg.giftLabel + ' (Wert ' + cfg.giftValue + ') – kommt automatisch in den Warenkorb'
        : '🎁 Noch <b>' + number.format(cfg.giftThreshold - m2) + ' m²</b> bis zum gratis Herbstdünger (Wert ' + cfg.giftValue + ')';
      el.giftBar.style.width = Math.min(100, Math.round(m2 / cfg.giftThreshold * 100)) + '%';
    }

    function renderSplit(m2) {
      if (!cfg.splitMax || m2 <= cfg.splitMax) { el.split.hidden = true; return; }
      var parts = Math.min(Math.ceil(m2 / cfg.splitMax), cfg.splitParts);
      el.split.innerHTML = '🚚 Lieferung in ' + parts + ' Teillieferungen (max. ' + cfg.splitMax + ' m² pro Tag) – Termine im Warenkorb.' +
        (m2 > cfg.splitMax * cfg.splitParts ? ' Die Aufteilung stimmen wir mit Ihnen ab.' : '');
      el.split.hidden = false;
    }

    /* ---------- Eingaben ---------- */
    function set(m2, keepInput) {
      state.m2 = clamp(m2);
      if (!keepInput) el.input.value = state.m2;
      el.limit.hidden = true;
      render();
      syncApp();
    }

    el.input.addEventListener('input', function () {
      var raw = parseInt(el.input.value, 10);
      if (isNaN(raw)) return;
      if (raw > cfg.max) {
        showLimit('Online bis ' + number.format(cfg.max) + ' m² bestellbar. Für größere Flächen: <a href="' + cfg.contactUrl + '">Angebot anfordern →</a>');
        state.m2 = cfg.max; render(); syncApp();
      } else if (raw < cfg.min) {
        showLimit(cfg.minHint);
      } else {
        set(raw, true);
      }
    });
    el.input.addEventListener('change', function () { set(parseInt(el.input.value, 10) || cfg.min); });
    function showLimit(html) { el.limit.innerHTML = html; el.limit.hidden = false; }

    root.querySelectorAll('[data-r-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var step = +b.getAttribute('data-r-step');
        var base = state.m2;
        var target = step > 0 ? Math.floor(base / 10) * 10 + 10 : Math.ceil(base / 10) * 10 - 10;
        set(target);
      });
    });

    /* Flächenrechner */
    el.measureToggle.addEventListener('click', function () {
      var open = el.measure.hidden;
      el.measure.hidden = !open;
      el.measureToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) el.length.focus();
    });
    function measure() {
      var l = parseFloat(String(el.length.value).replace(',', '.'));
      var w = parseFloat(String(el.width.value).replace(',', '.'));
      if (!(l > 0 && w > 0)) {
        el.measureResult.textContent = 'Länge und Breite eingeben – wir rechnen die Fläche aus.';
        return;
      }
      var area = l * w;
      var withReserve = el.reserve.checked ? area * 1.05 : area;
      var m2 = Math.ceil(withReserve);
      el.measureResult.innerHTML = number.format(Math.round(area * 10) / 10) + ' m²' +
        (el.reserve.checked ? ' + 5 % Reserve' : '') + ' = <b>' + number.format(m2) + ' m²</b>' +
        (m2 > cfg.max ? ' – bitte <a href="' + cfg.contactUrl + '">Angebot anfordern</a>' : '') +
        (m2 < cfg.min ? ' – ' + cfg.minHint : '');
      set(m2);
    }
    [el.length, el.width].forEach(function (f) { f.addEventListener('input', measure); });
    el.reserve.addEventListener('change', measure);

    /* ---------- Übergabe an die Apippa-App (bleibt unsichtbar, liefert den Preis-Token) ---------- */
    function appInput() { return document.querySelector('.cpc-calculator-placement input.numInput-cpc'); }
    function syncApp() {
      var input = appInput();
      if (!input) return;
      var v = String(state.m2);
      input.value = v;
      input.setAttribute('value', v);
      document.querySelectorAll('.cpc-calculator-placement .lookup-element-with-formula').forEach(function (lk) {
        var name = lk.getAttribute('data-calcname');
        var val = name === 'Input 1' ? '1' : name === 'Input 2' ? v : null;
        if (val !== null) { lk.value = val; lk.setAttribute('value', val); }
      });
    }

    function productForm() {
      var info = root.closest('.product-info') || document;
      return info.querySelector('form[action*="/cart/add"]');
    }
    /* Gratis-Dünger als echte Position in den Warenkorb legen (0 € über den automatischen Shopify-Rabatt).
       Der Klick wird kurz angehalten, der Dünger per /cart/add.js ergänzt und der Klick danach wiederholt. */
    var gift = { adding: false, done: false };
    function giftInCart(cart) {
      return cart.items.some(function (i) {
        return i.variant_id === cfg.giftVariantId && i.properties && i.properties._hdc_gratis;
      });
    }
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('button[name="add"], button[type="submit"]');
      var form = productForm();
      if (!btn || !form || !form.contains(btn)) return;
      syncApp();
      if (replaceKey) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var key = replaceKey;
        replaceKey = null;
        /* XHR statt fetch: der Gratis-Dünger-Schutz hängt sich an fetch(/cart/change) und würde die Seite neu laden */
        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/cart/change.js');
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.setRequestHeader('Accept', 'application/json');
        xhr.onloadend = function () { btn.click(); };
        xhr.send(JSON.stringify({ id: key, quantity: 0 }));
        return;
      }
      if (!cfg.giftEnabled || !cfg.giftVariantId || state.m2 < cfg.giftThreshold || gift.done) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (gift.adding) return;
      gift.adding = true;
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (giftInCart(cart)) return;
          return fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: cfg.giftVariantId, quantity: 1, properties: { _hdc_gratis: 'ab ' + cfg.giftThreshold + ' m² Rollrasen' } }] })
          });
        })
        .catch(function () {})
        .then(function () {
          gift.adding = false;
          gift.done = true;
          btn.click();
        });
    }, true);

    /* Die App rendert ihr Feld erst nach dem Laden – dann einmal übernehmen */
    var tries = 0;
    var wait = setInterval(function () {
      tries++;
      if (appInput()) { clearInterval(wait); syncApp(); }
      else if (tries > 120) clearInterval(wait);
    }, 250);

    /* Staffelpreise live aus der App-Konfiguration übernehmen */
    loadAppConfig(cfg).then(function (changed) {
      if (!changed) return;
      state.m2 = clamp(state.m2);
      el.input.min = cfg.min; el.input.max = cfg.max;
      /* z. B. ?flaeche=25 auf einer Seite mit App-Minimum 50: Anzeige an die tatsächlich berechnete Fläche angleichen */
      if (document.activeElement !== el.input && +el.input.value !== state.m2) el.input.value = state.m2;
      renderChips(); renderTiers(); render(); syncApp();
    }).catch(function () {});

    renderChips();
    renderTiers();
    render();
  }

  function loadAppConfig(cfg) {
    return fetch(API + 'calculator/app/productid/' + cfg.productId + '?shop=' + encodeURIComponent(cfg.shop))
      .then(function (r) { return r.json(); })
      .then(function (meta) {
        if (!meta || !meta.calcUniqueIden) return null;
        return fetch(API + 'calculator/app?calculatorId=' + meta.calcUniqueIden + '&productId=' + cfg.productId +
          '&isPreview=false&shop=' + encodeURIComponent(cfg.shop)).then(function (r) { return r.json(); });
      })
      .then(function (def) {
        var els = def && def.calculatorData && def.calculatorData.Elements;
        if (!els) return false;
        var numberEl = els.filter(function (e) { return e.ElementType === 'NumberInputNew' && e.options && e.options.length; })[0];
        if (!numberEl) return false;
        var tiers = numberEl.options.map(function (o) { return { from: +o.start, to: +o.end, price: +o.value }; })
          .filter(function (t) { return t.price > 0; });
        if (!tiers.length) return false;
        cfg.tiers = tiers;
        if (+numberEl.MinValue) cfg.min = +numberEl.MinValue;
        if (+numberEl.Maxvalue) cfg.max = +numberEl.Maxvalue;

        /* Lookup „Mindestmenge“: Zeilen = Bereiche von Input 2 (Fläche), Spalte 0 = Input 1 (= 1) */
        var lookup = els.filter(function (e) { return e.ElementType === 'Lookup' && e.sheet_data; })[0];
        if (lookup) {
          var ranges = lookup.sheet_data.input2_range.map(function (r) { return parseFloat(r); });
          var rows = lookup.sheet_data.data_lookup;
          var surcharge = [];
          ranges.forEach(function (start, i) {
            var amount = parseFloat(rows[i] && rows[i][0]) || 0;
            var end = i < ranges.length - 1 ? ranges[i + 1] - 1 : Infinity;
            if (amount > 0) surcharge.push({ from: start, to: end, amount: amount });
          });
          cfg.surcharge = surcharge;
        }
        return true;
      });
  }

  function start() { document.querySelectorAll('[data-hdc-rechner]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
